import { Unit } from './../../services/unit.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location, LocationService } from 'services/location.service';
import { MetaService } from 'services/meta.service';
import { Router } from '@angular/router';

@Component({
	selector: 'ras-select-unit-page',
	templateUrl: './select-unit-page.component.html',
	styleUrls: ['./select-unit-page.component.sass']
})
export class SelectUnitPageComponent implements OnInit {

	public location: Location = null;
	public location_lookup: Location[] = [];
	public unit_id: number = 0;
	public unit_size: string = "";
	public viewing_unit_3d: null | Unit;
	public next_unit_3d: null | Unit;
	public prev_unit_3d: null | Unit;
	public change = 0;
	public agnostic = false;

	constructor(private route: ActivatedRoute, private locationService: LocationService, private meta: MetaService, private router: Router) { }

	view_unit_in_3d(args) {
		if (args != null) {
			this.viewing_unit_3d = args[0]
			this.prev_unit_3d = args[1]
			this.next_unit_3d = args[2]
		} else {
			this.viewing_unit_3d = null
			this.prev_unit_3d = null
			this.next_unit_3d = null
		}
	}

	ngOnInit() {
		this.route.paramMap.subscribe(params => {
			let location_key = params.get('location')
			let unit_id_param = params.get('unit_id')
			switch (unit_id_param) {
				case 'small-storage-units':
				case 'small':
					this.unit_size = 'small'
					break
				case 'medium-storage-units':
				case 'medium':
					this.unit_size = 'medium'
					break
				case 'large-storage-units':
				case 'large':
					this.unit_size = 'large'
					break
				case 'storage-units':
					this.unit_id = 0
					break
				case 'parking-bays':
				case 'parking':
					this.unit_size = 'parking'
					break
				default: {
					let result = /^storage-unit-([0-9]*)$/.exec(unit_id_param)
					if (result && result.length > 1) {
						this.unit_id = Number.parseInt(result[1])
						if (!isNaN(this.unit_id)) break
					}
					this.router.navigate(['/storage-facility', location_key, 'storage-units'])
				}
			}

			this.locationService.get_all()
			.then(locations => {

				for (let location of locations) {
					if (location.id > 0) this.location_lookup[location.id] = location
				}

				for (let location of locations) {
					if (location.key == location_key) {
						this.location = location
						this.meta.apply('units-' + location_key)
						break
					}
				}
			})
		});
	}

}
